<template>
  <div class="popup-box flex flex-column" style="position: relative">
    <ul class="form-box">
      <el-config-provider
        :value-on-clear="null"
        :empty-values="[undefined, null]"
      >
        <el-form :model="state.model" ref="formDom" class="infoForm">
          <el-form-item
            label="子账户"
            prop="customer_subaccount_id"
            :rules="[
              { required: true, message: '请选择子账户', trigger: 'blur' },
            ]"
          >
            <el-select
              v-model="state.model.customer_subaccount"
              @change="onAccountChange"
            >
              <el-option
                v-for="item in state.account_data"
                :key="item"
                :label="item.name"
                :value="item"
              />
              <template #footer>
                <el-button size="small" @click="onLoadAccount()">
                  刷新
                </el-button>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item
            label="发票类型"
            prop="d_invoice_id"
            :rules="[
              { required: true, message: '请选择发票类型', trigger: 'blur' },
            ]"
          >
            <el-select v-model="state.model.d_invoice_id">
              <el-option
                v-for="item in state.invoice_data"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
              <template #footer>
                <el-button size="small" @click="onLoadInvoice()">
                  刷新
                </el-button>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item
            label="发票抬头"
            prop="title"
            :rules="[
              { required: true, message: '请填写发票抬头', trigger: 'blur' },
            ]"
          >
            <el-input v-model="state.model.title" />
          </el-form-item>
          <el-form-item
            label="统一社会信用代码"
            prop="s_unified_social_credit_identifier"
            :rules="[
              {
                required: true,
                message: '请填写统一社会信用代码',
                trigger: 'blur',
              },
            ]"
          >
            <el-input
              v-model="state.model.s_unified_social_credit_identifier"
            />
          </el-form-item>
          <el-form-item
            label="开票类型"
            prop="d_invoice_type_id"
            :rules="[
              { required: true, message: '请选择开票类型', trigger: 'blur' },
            ]"
          >
            <el-select v-model="state.model.d_invoice_type_id">
              <el-option
                v-for="item in state.invoicetype_data"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
              <template #footer>
                <el-button size="small" @click="onLoadInvoiceType()">
                  刷新
                </el-button>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item
            label="发票性质"
            prop="invoice_nature"
            :rules="[
              { required: true, message: '请选择发票性质', trigger: 'blur' },
            ]"
          >
            <el-select v-model="state.model.invoice_nature">
              <el-option label="普通发票" :value="0" />
              <el-option label="增值税发票" :value="1" />
            </el-select>
          </el-form-item>
          <el-form-item
            label="开票种类"
            prop="d_invoice_kind_id"
            :rules="[
              { required: true, message: '请选择开票种类', trigger: 'blur' },
            ]"
          >
            <el-select v-model="state.model.d_invoice_kind_id">
              <el-option
                v-for="item in state.invoicekind_data"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
              <template #footer>
                <el-button size="small" @click="onLoadInvoiceKind()"
                  >刷新</el-button
                >
              </template>
            </el-select>
          </el-form-item>
          <el-form-item
            label="联系电话"
            prop="contact_phone"
            :rules="[
              { required: true, message: '请填写联系电话', trigger: 'blur' },
            ]"
          >
            <el-input v-model="state.model.contact_phone" />
          </el-form-item>
          <el-form-item
            label="开票金额"
            prop="amount"
            :rules="[
              { required: true, message: '请填写开票金额', trigger: 'blur' },
            ]"
          >
            <el-input-number
              v-model="state.model.amount"
              :controls="false"
              class="number-input-left number-input-suffix"
              :precision="2"
              suffix="元"
            ></el-input-number>
          </el-form-item>
          <el-form-item
            label="开票备注"
            prop="invoice_remark"
            :rules="[
              { required: true, message: '请填写开票备注', trigger: 'blur' },
            ]"
          >
            <el-input v-model="state.model.invoice_remark" type="textarea" />
          </el-form-item>
          <template v-if="props.id">
            <el-form-item label="创建时间">
              <el-input v-model="state.model.create_time" disabled></el-input>
            </el-form-item>
            <el-form-item label="修改时间">
              <el-input v-model="state.model.update_time" disabled></el-input>
            </el-form-item>
          </template>
        </el-form>
      </el-config-provider>
    </ul>
    <ul class="submit-box">
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { customer_invoice_add } from "@/http/customer";
import { data_customer_subaccount_select } from "@/http/data";
import {
  invoice_select,
  invoicetype_select,
  invoicekind_select,
} from "@/http/dictionary";
import { post_response } from "@/utils/qFormat";

export default {
  props: {
    customer_id: Number,
    customer_code: String,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {},
    });
    onMounted(() => {
      state.model.customer_id = props.customer_id;
      state.model.unified_social_credit_identifier = props.customer_code;
      onLoadAccount();
      onLoadInvoice();
      onLoadInvoiceType();
      onLoadInvoiceKind();
    });

    //获取子账户
    const onLoadAccount = () => {
      data_customer_subaccount_select(props.customer_id).then((res) => {
        if (res.status === 200) state.account_data = res.data.data?.list;
      });
    };

    const onAccountChange = (item) => {
      state.model.customer_subaccount_id = item.id;
      state.model.s_unified_social_credit_identifier =
        item.unified_social_credit_identifier;
      state.model.title = item.invoice_title;
      state.model.d_invoice_id = item.d_invoice_id;
      state.model.d_invoice_type_id = item.d_invoice_type_id;
    };

    //发票类型
    const onLoadInvoice = () => {
      invoice_select().then((res) => {
        if (res.status === 200) state.invoice_data = res.data.data;
      });
    };

    //开票方式
    const onLoadInvoiceType = () => {
      invoicetype_select().then((res) => {
        if (res.status === 200) state.invoicetype_data = res.data.data;
      });
    };

    //开票种类
    const onLoadInvoiceKind = () => {
      invoicekind_select().then((res) => {
        if (res.status === 200) state.invoicekind_data = res.data.data;
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          customer_invoice_add(state.model).then((res) => {
            post_response(res, emit);
          });
        }
      });
    };
    return {
      state,
      props,
      formDom,
      onLoadAccount,
      onAccountChange,
      onLoadInvoice,
      onLoadInvoiceType,
      onLoadInvoiceKind,
      onSubmit,
    };
  },
};
</script>
<style scoped lang="less"></style>
